// extracted by mini-css-extract-plugin
export default {"offers":"styles_offers__TdoEb"};